/* import __COLOCATED_TEMPLATE__ from './matching-timetable.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();